import React, { useState, useCallback, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import { add, format, parseISO } from 'date-fns';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import {
  Button,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
} from '@material-ui/icons';
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import MainContainer from '../../components/MainContainer';
import MainHeader from '../../components/MainHeader';
import MainHeaderButtonsWrapper from '../../components/MainHeaderButtonsWrapper';
import Title from '../../components/Title';
import TableRowSkeleton from '../../components/TableRowSkeleton';

import api from '../../services/api';
import WhatsAppModal from '../../components/WhatsAppModal';
import ConfirmationModal from '../../components/ConfirmationModal';
import QrcodeModal from '../../components/QrcodeModal';
import { i18n } from '../../translate/i18n';
import { WhatsAppsContext } from '../../context/WhatsApp/WhatsAppsContext';
import toastError from '../../errors/toastError';
import formatSerializedId from '../../utils/formatSerializedId';
import { AuthContext } from '../../context/Auth/AuthContext';
import usePlans from '../../hooks/usePlans';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ForbiddenPage from '../../components/ForbiddenPage';
import { Can } from '../../components/Can';

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    // padding: theme.spacing(1),
    padding: theme.padding,
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: 'center',
  },
  buttonProgress: {
    color: green[500],
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position='relative' display='inline-flex'>
      <CircularProgress variant='determinate' {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Typography
          variant='caption'
          component='div'
          color='textSecondary'
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color='inherit'>
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  switch (channel) {
    case 'facebook':
      return <Facebook style={{ color: '#3b5998' }} />;
    case 'instagram':
      return <Instagram style={{ color: '#e1306c' }} />;
    case 'whatsapp':
      return <WhatsApp style={{ color: '#25d366' }} />;
    case 'whatsapp_oficial':
      return <WhatsApp style={{ color: '#25d366' }} />;
    default:
      return 'error';
  }
};

const Connections = () => {
  const classes = useStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState('whatsapp');
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: '',
    title: '',
    message: '',
    whatsAppId: '',
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(
    confirmationModalInitialState,
  );
  const [planConfig, setPlanConfig] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState('');
  const [targetConnection, setTargetConnection] = useState('');
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] =
    useState(false);
  const [transferProgress, setTransferProgress] = useState({
    current: 0,
    total: 0,
    percentage: 0,
  });

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== 'unknown') {
      const { accessToken, id } = response;

      api
        .post('/facebook', {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t('connections.facebook.success'));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== 'unknown') {
      const { accessToken, id } = response;

      api
        .post('/facebook', {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t('connections.facebook.success'));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    socket.on(`importMessages-${user.companyId}`, (data) => {
      if (data.action === 'refresh') {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === 'update') {
        setStatusImport(data.status);
      }
    });

    socket.on(`transferTickets-${user.companyId}`, (data) => {
      if (data.action === 'progress') {
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: Math.round((data.current / data.total) * 100),
        });
      }
      if (data.action === 'completed') {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.success(
          `Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`,
        );
        handleCloseTransferModal();
      }
      if (data.action === 'error') {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.error('Erro na transferência de tickets.');
      }
    });

    /* return () => {
      socket.disconnect();
    }; */
  }, [whatsApps]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    try {
      await api.post(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    try {
      await api.put(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel);
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel);
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  };

  const handleCopyWebhook = (url) => {
    navigator.clipboard.writeText(url); // Copia o token para a área de transferência
  };

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === 'disconnect') {
      setConfirmModalInfo({
        action: action,
        title: i18n.t('connections.confirmationModal.disconnectTitle'),
        message: i18n.t('connections.confirmationModal.disconnectMessage'),
        whatsAppId: whatsAppId,
      });
    }

    if (action === 'delete') {
      setConfirmModalInfo({
        action: action,
        title: i18n.t('connections.confirmationModal.deleteTitle'),
        message: i18n.t('connections.confirmationModal.deleteMessage'),
        whatsAppId: whatsAppId,
      });
    }
    if (action === 'closedImported') {
      setConfirmModalInfo({
        action: action,
        title: i18n.t('connections.confirmationModal.closedImportedTitle'),
        message: i18n.t('connections.confirmationModal.closedImportedMessage'),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === 'disconnect') {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === 'delete') {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t('connections.toasts.deleted'));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === 'closedImported') {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t('connections.toasts.closedimported'));
      } catch (err) {
        toastError(err);
      }
    }

    setConfirmModalInfo(confirmationModalInitialState);
  };

  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === 'renderButtonCloseTickets') {
      return (
        <Button
          style={{ marginLeft: 12 }}
          size='small'
          variant='outlined'
          color='primary'
          onClick={() => {
            handleOpenConfirmationModal('closedImported', whatsApp.id);
          }}
        >
          {i18n.t('connections.buttons.closedImported')}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime(),
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages),
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                style={{ marginLeft: 12 }}
                size='small'
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant='outlined'
                color='primary'
              >
                {i18n.t('connections.buttons.preparing')}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    return (
      <>
        {whatsApp.channel === 'whatsapp' && whatsApp.status === 'qrcode' && (
          <Can
            role={
              user.profile === 'user' && user.allowConnections === 'enabled'
                ? 'admin'
                : user.profile
            }
            perform='connections-page:addConnection'
            yes={() => (
              <Button
                size='small'
                variant='contained'
                color='primary'
                onClick={() => handleOpenQrModal(whatsApp)}
              >
                {i18n.t('connections.buttons.qrcode')}
              </Button>
            )}
          />
        )}
        {whatsApp.channel === 'whatsapp' &&
          whatsApp.status === 'DISCONNECTED' && (
            <Can
              role={
                user.profile === 'user' && user.allowConnections === 'enabled'
                  ? 'admin'
                  : user.profile
              }
              perform='connections-page:addConnection'
              yes={() => (
                <>
                  <Button
                    size='small'
                    variant='outlined'
                    color='primary'
                    onClick={() => handleStartWhatsAppSession(whatsApp.id)}
                  >
                    {i18n.t('connections.buttons.tryAgain')}
                  </Button>{' '}
                  <Button
                    size='small'
                    variant='outlined'
                    color='secondary'
                    onClick={() => handleRequestNewQrCode(whatsApp.id)}
                  >
                    {i18n.t('connections.buttons.newQr')}
                  </Button>
                </>
              )}
            />
          )}
        {whatsApp.channel === 'whatsapp' &&
          (whatsApp.status === 'CONNECTED' ||
            whatsApp.status === 'PAIRING' ||
            whatsApp.status === 'TIMEOUT') && (
            <Can
              role={user.profile}
              perform='connections-page:addConnection'
              yes={() => (
                <>
                  <Button
                    size='small'
                    variant='outlined'
                    color='secondary'
                    onClick={() => {
                      handleOpenConfirmationModal('disconnect', whatsApp.id);
                    }}
                  >
                    {i18n.t('connections.buttons.disconnect')}
                  </Button>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {whatsApp.channel === 'whatsapp' && whatsApp.status === 'OPENING' && (
          <Button size='small' variant='outlined' disabled color='default'>
            {i18n.t('connections.buttons.connecting')}
          </Button>
        )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    return (
      <div className={classes.customTableCell}>
        {whatsApp.status === 'DISCONNECTED' && (
          <CustomToolTip
            title={i18n.t('connections.toolTips.disconnected.title')}
            content={i18n.t('connections.toolTips.disconnected.content')}
          >
            <SignalCellularConnectedNoInternet0Bar color='secondary' />
          </CustomToolTip>
        )}
        {whatsApp.status === 'OPENING' && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {whatsApp.status === 'qrcode' && (
          <CustomToolTip
            title={i18n.t('connections.toolTips.qrcode.title')}
            content={i18n.t('connections.toolTips.qrcode.content')}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {whatsApp.status === 'CONNECTED' && (
          <CustomToolTip title={i18n.t('connections.toolTips.connected.title')}>
            <SignalCellular4Bar style={{ color: green[500] }} />
          </CustomToolTip>
        )}
        {(whatsApp.status === 'TIMEOUT' || whatsApp.status === 'PAIRING') && (
          <CustomToolTip
            title={i18n.t('connections.toolTips.timeout.title')}
            content={i18n.t('connections.toolTips.timeout.content')}
          >
            <SignalCellularConnectedNoInternet2Bar color='secondary' />
          </CustomToolTip>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {
    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t('connections.waitConnection'));
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection('');
    setTargetConnection('');
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0 });
  };

  const handleTransferTickets = async () => {
    if (!sourceConnection || !targetConnection) {
      toast.error('Selecione as conexões de origem e destino');
      return;
    }

    if (sourceConnection === targetConnection) {
      toast.error('As conexões de origem e destino devem ser diferentes');
      return;
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: sourceConnection,
        targetConnectionId: targetConnection,
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({
          current: 0,
          total: response.data.totalTickets,
          percentage: 0,
        });
      } else {
        toast.success(
          `Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`,
        );
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal('delete', whatsAppToDelete);
    setWhatsAppToDelete(null);
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Transferência de Tickets</DialogTitle>
        <DialogContent>
          <Typography
            variant='body1'
            style={{ marginBottom: 24, lineHeight: 1.6 }}
          >
            Para transferir os tickets, selecione a conexão de{' '}
            <strong>origem</strong> (de onde os tickets serão movidos) e a
            conexão de <strong>destino</strong> (para onde os tickets serão
            transferidos). Todos os atendimentos ativos da conexão de origem
            serão movidos para a conexão de destino.
          </Typography>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 24,
              marginBottom: 24,
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Origem</InputLabel>
              <Select
                value={sourceConnection}
                onChange={(e) => setSourceConnection(e.target.value)}
                label='Origem'
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ fontSize: 24, color: '#4caf50', fontWeight: 'bold' }}>
              →
            </div>

            <FormControl fullWidth>
              <InputLabel>Destino</InputLabel>
              <Select
                value={targetConnection}
                onChange={(e) => setTargetConnection(e.target.value)}
                label='Destino'
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransferModal} color='default'>
            CANCELAR
          </Button>
          <Button
            onClick={handleTransferTickets}
            color='primary'
            variant='contained'
          >
            TRANSFERIR
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={transferProgressModalOpen}
        onClose={handleCloseTransferProgressModal}
        maxWidth='sm'
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle>Transferindo Tickets</DialogTitle>
        <DialogContent>
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Typography variant='h6' style={{ marginBottom: 16 }}>
              Progresso da Transferência
            </Typography>

            <Box position='relative' display='inline-flex' marginBottom={2}>
              <CircularProgress
                variant='determinate'
                value={transferProgress.percentage}
                size={80}
                thickness={4}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position='absolute'
                display='flex'
                alignItems='center'
                justifyContent='center'
              >
                <Typography
                  variant='caption'
                  component='div'
                  color='textSecondary'
                  style={{ fontSize: '14px', fontWeight: 'bold' }}
                >
                  {transferProgress.percentage}%
                </Typography>
              </Box>
            </Box>

            <Typography variant='body1' style={{ marginTop: 16 }}>
              {transferProgress.current} de {transferProgress.total} tickets
              transferidos
            </Typography>

            <Typography
              variant='body2'
              color='textSecondary'
              style={{ marginTop: 8 }}
            >
              Por favor, aguarde enquanto os tickets são transferidos...
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={preDeleteModalOpen}
        onClose={handleClosePreDeleteModal}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Transferência de Tickets</DialogTitle>
        <DialogContent>
          <Typography variant='body1' style={{ marginBottom: 16 }}>
            Antes de excluir esta conexão, você já fez a transferência dos
            tickets para outra conexão?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreDeleteModal} color='default'>
            NÃO
          </Button>
          <Button
            onClick={handleConfirmTransferDone}
            color='primary'
            variant='contained'
          >
            SIM
          </Button>
        </DialogActions>
      </Dialog>
      {user.profile === 'user' && user.allowConnections === 'disabled' ? (
        <ForbiddenPage />
      ) : (
        <>
          <MainHeader>
            <Title>
              {i18n.t('connections.title')} ({whatsApps.length})
            </Title>
            <MainHeaderButtonsWrapper>
              <Button
                variant='contained'
                color='primary'
                onClick={handleOpenTransferModal}
              >
                Transferir Tickets
              </Button>

              <Button
                variant='contained'
                color='primary'
                onClick={restartWhatsapps}
              >
                {i18n.t('connections.restartConnections')}
              </Button>

              <Button
                variant='contained'
                color='primary'
                onClick={() =>
                  openInNewTab(
                    `https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`,
                  )
                }
              >
                {i18n.t('connections.callSupport')}
              </Button>
              <PopupState variant='popover' popupId='demo-popup-menu'>
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform='connections-page:addConnection'
                      yes={() => (
                        <>
                          <Button
                            variant='contained'
                            color='primary'
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t('connections.newConnection')}
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={
                                planConfig?.plan?.useWhatsapp ? false : true
                              }
                              onClick={() => {
                                handleOpenWhatsAppModal();
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize='small'
                                style={{
                                  marginRight: '10px',
                                  color: '#25D366',
                                }}
                              />
                              WhatsApp
                            </MenuItem>
                            {/* WHATSAPP OFICIAL */}
                            <MenuItem
                              disabled={
                                planConfig?.plan?.useWhatsappOfficial
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleOpenWhatsAppModal('whatsapp_oficial');
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize='small'
                                style={{
                                  marginRight: '10px',
                                  color: '#25D366',
                                }}
                              />
                              WhatsApp Oficial
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields='name,email,picture'
                              version='9.0'
                              scope='public_profile,email'
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={
                                    planConfig?.plan?.useFacebook ? false : true
                                  }
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize='small'
                                    style={{
                                      marginRight: '10px',
                                      color: '#3b5998',
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}

                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields='name,email,picture'
                              version='23.0'
                              scope='
                                public_profile,
                                pages_show_list,
                                pages_manage_metadata,
                                pages_read_engagement,
                                business_management,
                                instagram_basic,
                                instagram_manage_messages
                            '
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={
                                    planConfig?.plan?.useInstagram
                                      ? false
                                      : true
                                  }
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize='small'
                                    style={{
                                      marginRight: '10px',
                                      color: '#e1306c',
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </MainHeaderButtonsWrapper>
          </MainHeader>

          {statusImport?.all ? (
            <>
              <div style={{ margin: 'auto', marginBottom: 12 }}>
                <Card className={classes.root}>
                  <CardContent className={classes.content}>
                    <Typography component='h5' variant='h5'>
                      {statusImport?.this === -1
                        ? i18n.t('connections.buttons.preparing')
                        : i18n.t('connections.buttons.importing')}
                    </Typography>
                    {statusImport?.this === -1 ? (
                      <Typography component='h6' variant='h6' align='center'>
                        <CircularProgress size={24} />
                      </Typography>
                    ) : (
                      <>
                        <Typography component='h6' variant='h6' align='center'>
                          {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                        </Typography>
                        <Typography align='center'>
                          <CircularProgressWithLabel
                            style={{ margin: 'auto' }}
                            value={
                              (statusImport?.this / statusImport?.all) * 100
                            }
                          />
                        </Typography>
                      </>
                    )}
                  </CardContent>
                </Card>
              </div>
            </>
          ) : null}

          <Paper className={classes.mainPaper} variant='outlined'>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Channel</TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.color')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.name')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.number')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.status')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.session')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.lastUpdate')}
                  </TableCell>
                  <TableCell align='center'>
                    {i18n.t('connections.table.default')}
                  </TableCell>
                  <Can
                    role={
                      user.profile === 'user' &&
                      user.allowConnections === 'enabled'
                        ? 'admin'
                        : user.profile
                    }
                    perform='connections-page:addConnection'
                    yes={() => (
                      <TableCell align='center'>
                        {i18n.t('connections.table.actions')}
                      </TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton />
                ) : (
                  <>
                    {whatsApps?.length > 0 &&
                      whatsApps.map((whatsApp) => (
                        <TableRow key={whatsApp.id}>
                          <TableCell align='center'>
                            {IconChannel(whatsApp.channel)}
                          </TableCell>
                          <TableCell align='center'>
                            <div className={classes.customTableCell}>
                              <span
                                style={{
                                  backgroundColor: whatsApp.color,
                                  width: 60,
                                  height: 20,
                                  alignSelf: 'center',
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell align='center'>{whatsApp.name}</TableCell>
                          <TableCell align='center'>
                            {whatsApp.channel === 'whatsapp' &&
                            whatsApp.number ? (
                              <>{formatSerializedId(whatsApp.number)}</>
                            ) : whatsApp.channel === 'whatsapp_oficial' &&
                              whatsApp.phone_number ? (
                              <>{formatSerializedId(whatsApp.phone_number)}</>
                            ) : (
                              '-'
                            )}
                          </TableCell>
                          <TableCell align='center'>
                            {renderStatusToolTips(whatsApp)}
                          </TableCell>
                          <TableCell align='center'>
                            {renderActionButtons(whatsApp)}
                          </TableCell>
                          <TableCell align='center'>
                            {format(
                              parseISO(whatsApp.updatedAt),
                              'dd/MM/yy HH:mm',
                            )}
                          </TableCell>
                          <TableCell align='center'>
                            {whatsApp.isDefault && (
                              <div className={classes.customTableCell}>
                                <CheckCircle style={{ color: green[500] }} />
                              </div>
                            )}
                          </TableCell>
                          <Can
                            role={user.profile}
                            perform='connections-page:addConnection'
                            yes={() => (
                              <TableCell align='center'>
                                <IconButton
                                  size='small'
                                  onClick={() => handleEditWhatsApp(whatsApp)}
                                >
                                  <Edit />
                                </IconButton>

                                <IconButton
                                  size='small'
                                  onClick={(e) => {
                                    handleOpenPreDeleteModal(whatsApp.id);
                                  }}
                                >
                                  <DeleteOutline />
                                </IconButton>
                                {whatsApp.channel === 'whatsapp_oficial' && (
                                  <>
                                    <Tooltip title='Sincronizar templates'>
                                      <IconButton
                                        size='small'
                                        aria-label='sync-templates'
                                        onClick={(e) => {
                                          handleSyncTemplates(whatsApp.id);
                                        }}
                                      >
                                        <Sync />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title='Copiar webhook para Meta'>
                                      <IconButton
                                        size='small'
                                        aria-label='copy-webhook'
                                        onClick={(e) => {
                                          handleCopyWebhook(
                                            whatsApp.waba_webhook,
                                          );
                                        }}
                                      >
                                        <WebhookIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </TableCell>
                            )}
                          />
                        </TableRow>
                      ))}
                  </>
                )}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </MainContainer>
  );
};

export default Connections;
